import type {
  CreateAgentDeployChatWidget,
  UpdateAgentDeployChatWidget,
} from "@/schemas/agent-deploy-chat-widget.schema";
import { api } from "@/services/api";

export const agentDeployChatWidgetApi = {
  async create(agentId: string, form: CreateAgentDeployChatWidget) {
    const { data } = await api.post<CreateAgentDeployChatWidget>(
      `/agent-deploy-chat-widget/${agentId}`,
      form
    );

    return data;
  },

  async updateById(agentId: string, form: UpdateAgentDeployChatWidget) {
    await api.patch(`/agent-deploy-chat-widget/${agentId}`, form);
  },
};
